export enum OSOptions {
    IOS = "iOS",
    ANDROID = "Android",
}
